import { render, staticRenderFns } from "./LifePerformance.vue?vue&type=template&id=476317c2&scoped=true&"
import script from "./LifePerformance.vue?vue&type=script&lang=js&"
export * from "./LifePerformance.vue?vue&type=script&lang=js&"
import style0 from "./LifePerformance.vue?vue&type=style&index=0&id=476317c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476317c2",
  null
  
)

export default component.exports